import { Tooltip, withStyles } from '@material-ui/core'

const InfoTooltip = withStyles((theme) => ({
	tooltip: {
		fontSize: '1rem',
		maxWidth: 500
	}
}))(Tooltip)

export default InfoTooltip
